import { ReactNode, RefObject, SyntheticEvent, useState } from "react";

import { useOutSideClick } from "src/hooks/outSideClick";

import './style.scss';

interface IProps {
  children: ReactNode;
  anchorRef?: RefObject<HTMLElement>;
  offset?: number;
};

const InfoIcon = ({ children, anchorRef, offset = 0 }: IProps) => {
  const [open, setOpen] = useState(false);
  const toggleRef = useOutSideClick(() => setOpen(false), []);

  const anchorElem = anchorRef?.current || toggleRef.current;
  const anchorPosition = anchorElem?.getBoundingClientRect();

  const toggleOpen = (e: SyntheticEvent) => {
    e.preventDefault();
    setOpen(!open);
  }

  return (
    <>
      <div className="B-betslip-info-icon">
        <div ref={toggleRef} className="B-toggle" onClick={toggleOpen}>
          <i className="B-info-icon global-icon icon-info-circle" />
        </div>
      </div>
      {open && <div
        className="B-betslip-info-icon-content"
        style={{ top: (anchorPosition?.top || 0) - offset, left: anchorPosition?.right }}
      >{children}</div>}
    </>
  );
}

export default InfoIcon;